module.exports = __webpack_public_path__ + "img/grupoColor.db6e3459.jpg";